import { AccountLinkModel } from 'src/Libs/installation-rights-management/models'
import { AccountSourceType } from 'src/Libs/installation-rights-management/types'
import { PermissionType } from 'src/Libs/types/common'
import { AccountLinkListDto } from '../dto/account-links.dto'

const accountLinksToModelTransformer = (values: AccountLinkListDto): AccountLinkModel[] => {
  return values.id.map((id, index) => ({
    id: Number(id),
    installationId: values.installationId[index] || -1,
    accountId: values.accountId[index] || -1,
    accountType: values.accountType[index] || -1,
    accountSource: (values.accountSource[index] as AccountSourceType) || 'e3dc',
    role: values.role[index] || 'user',
    inviteId: values.inviteId[index] || '',
    startAt: values.startAt[index] || '',
    stopAt: values.stopAt[index] || '',
    permissionType: (values.permissionType[index] as PermissionType) || 'ro',
    storagePermissionType: (values.storagePermissionType[index] as PermissionType) || 'ro',
    userName: values.userName[index] || '',
    firstName: values.firstName[index] || '',
    lastName: values.lastName[index] || '',
    companyName: values.companyName ? values.companyName[index] : '',
    createdAt: values.createdAt[index] || '',
    updatedAt: values.updatedAt[index] || '',
    deletedAt: values.deletedAt ? values.deletedAt[index] : '',
    hasReadAccess: values.permissionType[index] === 'rw' || values.permissionType[index] === 'ro',
    hasWriteAccess: values.permissionType[index] === 'rw',
    hasHagerEnergyApiAccess: values.hasHagerEnergyApiAccess ? values.hasHagerEnergyApiAccess[index] : false,
  }))
}

export default accountLinksToModelTransformer
